import {Controller} from "stimulus";
import {objectToFormData} from "../../assets/forms";

export default class extends Controller {

  static url = ''
  static event = ''

  connect() {
    console.log('')
    if (this.constructor.event !== '') {
      this.onClick = (e) => this.sendEvent();
      this.element.addEventListener('click', this.onClick);
    }

    if ((this.constructor.url !== '') && ('machineId' in this.element.dataset)) {
      this.onClick = (e) => this.countClick(e, this.element.dataset);
      this.element.addEventListener('click', this.onClick);
    }
  }

  countClick(e, dataset) {
    console.log('here');

    fetch(this.constructor.url, {
      method: 'POST',
      body: objectToFormData({
        machine_id: dataset.machineId,
        location: dataset.location
      })
    })

  }

  sendEvent() {
    if (this.constructor.event !== '') {
      window.dataLayer.push({
        event: this.constructor.event
      });
    }
  }
}
